import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgOtpInputModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'sbcheckout-web';
}
